import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 * @deprecated since version 8.1.0
 * @tdr-deprecated-date: 2022-04-11
 */
export default svgIcon(React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" },
    React.createElement("path", { d: "M14.8 15.2l7.5-1.8c.8-.1 1.7.3 2 1l3.5 8.2c.3.7 0 1.5-.5 2l-4.4 3.6a27 27 0 0 0 12.9 12.9l3.6-4.4c.5-.6 1.3-.8 2-.5l8.1 3.5c.8.3 1.2 1.2 1 2l-1.7 7.5c-.2.8-.9 1.4-1.7 1.4-18.6 0-33.7-15-33.7-33.7 0-.8.6-1.5 1.4-1.7z", fill: "currentColor" })), 'PhoneHandset');
//# sourceMappingURL=PhoneHandset.js.map